import React from "react";
import { Translate } from "react-auto-translate";

export default function Call({
  country,
  docTitle,
  docLink,
  formTitle,
  formLink,
}) {
  return (
    <div className="flex flex-column gap-2 px-2 md:px-4 mt-5">
      <span>
        <Translate>{country}</Translate>
      </span>

      <a
        href={docLink}
        target="_blank"
        rel="noreferrer noopener"
        className="text-white no-underline bg-blue-500 p-1 border-round "
      >
        <p className="font-bold text-center text-sm">
          <Translate>{docTitle}</Translate>
        </p>
      </a>
      <a
        href={formLink}
        target="_blank"
        rel="noreferrer noopener"
        className="text-white no-underline bg-orange-500 p-1 border-round "
      >
        <p className="font-bold text-center text-sm">
          <Translate>{formTitle}</Translate>
        </p>
      </a>
    </div>
  );
}
